<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div class="part">
<p class="noindent_paraf"> </p>
<p class="common"><span epub:type="pagebreak" id="page_viii" title="viii"><img alt="" src="images/common.jpg" style="width: 15%"/></span></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter04.vue?97574a3e